import { Box, Image, Stack, Text, Title } from '@mantine/core';

import { IconArrowRight } from '@tabler/icons-react';
import { Link } from 'react-router-dom';

import { Button } from '../../../shared/components/UI/Button/Button';

import { DecisionRenewalStatus } from '../../../shared/entities/Interaction';
import EmptyToAnalyseIllustration from '../assets/empty_to_analyse_illustration.svg';

type EmptyDecisionListProps = {
  decisionRenewalStatus: DecisionRenewalStatus;
};
export const EmptyDecisionRenewalList = ({
  decisionRenewalStatus,
}: EmptyDecisionListProps) => {
  const config = {
    title: "Vous n'avez pas d'opportunités à analyser pour l'instant",
    subtitle:
      "Ajoutez de nouveaux appels d'offres depuis vos flux d'opportunités pour les analyser ici.",
    illustration: EmptyToAnalyseIllustration,
  };

  return (
    <Box
      h="100%"
      mx="05"
      bg="linear-gradient(180deg, #F7FBFF 34%, rgba(247, 251, 255, 0) 100%)"
      sx={theme => ({ borderRadius: theme.radius.md })}
    >
      <Stack align="center" spacing="05" m="10%">
        <Image
          src={config.illustration}
          alt="Illustration de liste d'appels d'offre vide"
          maw="116px"
          mah="116px"
        />
        <Stack spacing="02" align="center">
          <Title align="center" order={4} c="gray.9" maw="480px">
            {config.title}
          </Title>
          <Text variant="sm" fw={400} c="gray.3" align="center" maw="80%">
            {config.subtitle}
          </Text>
        </Stack>
        {decisionRenewalStatus === DecisionRenewalStatus.TO_ANALYZE && (
          <Button
            variant="filled"
            color="primary"
            size="lg"
            rightIcon={<IconArrowRight />}
            component={Link}
            to="/flux"
          >
            Découvrir de nouvelles opportunités
          </Button>
        )}
      </Stack>
    </Box>
  );
};
